import Vue from "vue"
import Vuex from "vuex"
 
Vue.use(Vuex);
 
export default new Vuex.Store({
    state:{
        UserInfo: {}
    },
    mutations:{
        // 保存当前菜单栏的路径
        saveUserInfo(state,UserInfo){
            state.UserInfo = UserInfo;
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js